import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const trigger = event.currentTarget
    const targetId = trigger.dataset.targetId
    const panel = this.panelTargets.find(el => `#${el.id}` === targetId)

    if (!panel) return

    const isOpen = panel.classList.contains("show")

    // Fermer tous les autres panels de ce contrôleur
    this.panelTargets.forEach(el => {
      el.classList.remove("show")
      el.style.maxHeight = null
    })

    // Ouvrir celui cliqué
    if (!isOpen) {
      panel.classList.add("show")
      panel.style.maxHeight = panel.scrollHeight + "px"
    }
  }

  connect() {
    this.panelTargets.forEach(panel => {
      if (panel.classList.contains("show")) {
        panel.style.maxHeight = panel.scrollHeight + "px"
      }
    })
  }
}
